import React from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "store/customer/action";

const Dependents = ({ customer, updateCustomer, callback }) => {
  const deleteDependent = (index) => {
    customer.dependents.splice(index, 1);
    const updatedCustomer = {
      id: customer.id,
      _version: customer._version,
      dependents: customer.dependents,
    };
    updateCustomer(updatedCustomer, callback);
  };

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col">
        <div className="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div className="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
            <table className="min-w-full">
              <thead>
                <tr>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Name
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                    Surname
                  </th>
                  <th className="px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"></th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {(!customer?.dependents || customer?.dependents?.length == 0) && (
                  <tr>
                    <td
                      className="mx-auto px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500"
                      colSpan="3"
                    >
                      No members
                    </td>
                  </tr>
                )}
                {customer?.dependents?.map((dependent, index) => {
                  return (
                    <tr key={dependent.givenName}>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {dependent.givenName}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        {dependent.familyName}
                      </td>
                      <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 text-sm leading-5 text-gray-500">
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            deleteDependent(index);
                          }}
                          className="inline-flex  py-1 px-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    customer: state.customer.item,
  };
};

const mapDispatchToProps = (dispatch) => ({
  updateCustomer: (item, callback) =>
    dispatch(ACTIONS.updateItem(item, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Dependents);
